import { render } from "./BaseBreadcrumbs.vue?vue&type=template&id=870e5de2"
import script from "./BaseBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./BaseBreadcrumbs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__